import { useEffect } from "react";
import { ChatMessager } from "./chat-messager";
import { ChatMessages } from "./chat-messages";
import { CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1MessageFieldsFragment, PaymentInstrument } from "../../../generated";
import { Country } from "../../../types/country";

export type CaseMessage = CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1MessageFieldsFragment & Message;

export interface Message {
  id: string;
  sentBy: string;
  message: string;
  embedding: string | undefined;
  createdAt: string;
}

export interface CaseData {
  messages: CaseMessage[];
  applicant: {
    lastName: string;
    restOfName: string;
  };
}

interface ChatPageProps {
  cyberSourcePublicKey: any;
  applicantId: any;
  data: CaseData;
  updateMessage: () => void;
  onSave: (data: { id: string; messages: { id?: string; sentBy?: string; message?: string; embedding?: string }[] }) => Promise<void>;
  startPollingMessages: (interval: number) => void;
  pollingMessagesData: { data: { id: string, messages: { id?: string; sentBy?: string; message?: string; embedding?: string }[] }};
  stopPollingMessages: () => void;
  caseId: string;
  transactions:any;
  paymentInstrument: PaymentInstrument;
  country: Country[]
  disabled?: boolean;
}

export const Messages: React.FC<ChatPageProps> = ({disabled = false, ...props}) => {
  useEffect(() => {}, [props.data]);

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      position: 'static',
      justifyContent: 'flex-end',
      alignItems: 'center', 
      paddingTop: 50, 
      width: "100%", 
      height: "calc(100vh - 100px)", 
      maxHeight: 'calc(100vh - 145px)',
    }}>
      <ChatMessages
        data={props.data}
        onSave={props.onSave}
        startPollingMessages={props.startPollingMessages}
        pollingMessagesData={props.pollingMessagesData}
        stopPollingMessages={props.stopPollingMessages}
        isAdmin={false}
        caseId={props.caseId}
        transactions={props.transactions}
        paymentInstrument={props.paymentInstrument}
        applicantId={props.applicantId}
        country={props.country}
        cyberSourcePublicKey= {props.cyberSourcePublicKey}
      /> 
      <ChatMessager
        disabled={disabled}
        updateMessage={props.updateMessage}
        onSave={props.onSave}
        caseId={props.caseId}
      />
    </div>
  );
};
